import styled from "styled-components";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

// Styled fixed-size external icon – its width/height are fixed.
export const FixedExternalIcon = styled(ArrowTopRightOnSquareIcon)`
  width: 16px;
  height: 16px;
  margin-left: 0px;
  flex-shrink: 0;
`;